export const DETAIL_ACTION_TYPES = {
  DETAIL_IS_LOADING: "DETAIL_IS_LOADING",
  DETAILS_SUCCESS: "DETAILS_SUCCESS",
  DETAILS_CLEAR: "DETAILS_CLEAR",
  DETAILS_SIMILAR_MOVIES: " DETAILS_SIMILAR_MOVIES",
  DETAILS_MOVIES_TRAILERS: "DETAILS_MOVIES_TRAILERS",
  DETAILS_CAST: "DETAILS_CAST",
  DETAIL_ERROR: "DETAIL_ERROR",
};
